var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportHeartOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47266 1.96786L9 2.70714L9.52734 1.96786C10.4062 0.732143 11.8195 0 13.3207 0C15.9047 0 18 2.12857 18 4.75357V4.84643C18 8.85357 13.0816 13.5071 10.5152 15.4964C10.0793 15.8321 9.54492 16 9 16C8.45508 16 7.91719 15.8357 7.48477 15.4964C4.91836 13.5071 0 8.85357 0 4.84643V4.75357C0 2.12857 2.09531 0 4.6793 0C6.18047 0 7.59375 0.732143 8.47266 1.96786Z",
    fill: "#F46940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportHeartOn);
export default __webpack_public_path__ + "static/media/reportHeartOn.73569373b65456d9d6ff1dff715f0e78.svg";
export { ForwardRef as ReactComponent };